/**
* =========================================================================================
* Component - Time Picker
* =========================================================================================
* 
**/
 
import React, { useEffect, useState } from 'react';
import 'rc-time-picker/assets/index.css';

// Packages
import TimePicker from 'rc-time-picker'; /* TimePicker */

const UTimePicker = (props) => { 
    
    return (
        <div className={`u_timepicker ${props.fullWidth ? 'u_timepicker-full' : ''} ${props.className || ''}`}  >
            <TimePicker
                {...props}
                open={props.open}
                onOpen={props.onOpen}
                onClose={props.onClose}
                autoComplete='off'
                clearIcon={<div className="u_timepicker_reset">{props.clearIcon}</div>}
            />
            {props.recurring && <div className="u_recurring">{props.recurring}</div>}
        </div>
    );
}

export default UTimePicker;